import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import { Link, Navigate } from "react-router-dom";

export default class Projects extends Component {
  state = {
    projects: [],
    per_page: 20,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    notiColor: "success",
    notification: false,
    message: "",
    loading: false,
    redirect: false,
  };

  componentDidMount() {
    this.getAllProjects(this.state.page_no, this.state.per_page);
  }

  getAllProjects = (page = 1, limit = 20) => {
    if (init() == "success") {
      this.setState({ loading: true });

      axios
        .get(`${Constants.getUrls.getAllProjects}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp.data?.status === "success") {
            const data = resp.data.data;

            this.setState({
              projects: data.docs || [],
              pagination: {
                page: data.page,
                limit: data.limit,
                totalDocs: data.totalDocs,
                totalPages: data.totalPages,
                hasNextPage: data.hasNextPage,
                hasPrevPage: data.hasPrevPage,
                nextPage: data.nextPage,
                prevPage: data.prevPage,
              },
              page_no: data.page,
              loading: false,
            });
          } else {
            this.showSnackbar(
              "warning",
              resp.data?.message || "Failed to load projects"
            );
          }
        })
        .catch(() => {
          this.showSnackbar("warning", "Something went wrong!");
        });
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllProjects(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllProjects(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this project?"))
      return;

    axios
      .delete(Constants.deleteUrls.deleteProject + id)
      .then((resp) => {
        this.showSnackbar("success", resp.data?.message || "Project deleted");
        this.getAllProjects(this.state.pagination.page, this.state.per_page);
      })
      .catch(() => {
        this.showSnackbar("warning", "Delete failed");
      });
  };

  showSnackbar = (color, message) => {
    this.setState({ notification: true, notiColor: color, message });
    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 2500);
  };

  render() {
    const { projects, pagination, loading, redirect } = this.state;

    if (redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            {/* HEADER */}
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Projects
              </MDTypography>
            </MDBox>

            {/* CREATE */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addNewProject">
                <MDButton variant="contained" size="small" color="primary">
                  Create Project
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : projects.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial", width: "6%" },
                      { Header: "Project Name", accessor: "name" },
                      { Header: "Category", accessor: "category" },
                      { Header: "Location", accessor: "location" },
                      { Header: "Banner", accessor: "banner" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: projects.map((project, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit + (index + 1),

                      name: project.project_name,

                      category: project.project_category?.name || "—",

                      location: project.project_location || "—",

                      banner: project.project_banner ? (
                        <img
                          src={Constants.imageDomain + project.project_banner}
                          alt="Project Banner"
                          style={{
                            height: "80px",
                            width: "140px",
                            objectFit: "cover",
                            borderRadius: "6px",
                          }}
                        />
                      ) : (
                        "—"
                      ),

                      action: (
                        <div style={{ display: "flex", gap: "10px" }}>
                          <Tooltip title="Edit Project">
                            <Link to={`/updateproject/${project?._id}`}>
                              <IconButton size="small" color="info">
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete Project">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => this.handleDelete(project._id)}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  isnextPage={pagination.nextPage}
                  prevPage={pagination.prevPage}
                  totalDocs={pagination.totalDocs}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Projects Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Projects Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
